import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { mapToVoid } from '@examdojo/rxjs';
import { of, take } from 'rxjs';
import { ClassAssignmentService } from './class-assignment.service';

export const classAssignmentResolver: ResolveFn<void> = () => {
  const classAssignmentService = inject(ClassAssignmentService);
  const errorHandlerService = inject(ErrorHandlerService);

  return classAssignmentService.init().pipe(
    errorHandlerService.catchHttpErrors(() => of(undefined)),
    take(1),
    mapToVoid(),
  );
};
